import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_view.png';

const _withScopeId = n => (_pushScopeId("data-v-a6111626"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "channelEdit-container"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "margin": "5px 5px 5px 0"
  }
};
const _hoisted_3 = {
  key: 0
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_5 = {
  class: "mg-l--5"
};
const _hoisted_6 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_7 = {
  class: "img_box"
};
const _hoisted_8 = {
  class: "icon_btn"
};
const _hoisted_9 = {
  key: 0,
  class: "dialog-footer"
};
import { computed, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getLanguageListApi, getLiveCategoryOptionsApi, getLiveCategorySequencesApi, getcountryListApi, getImageUrlByUploadApi } from '@/api/live';
import { useI18n } from 'vue-i18n';
import { liveStore } from '@/store/liveStore';
import { playLevelObj } from '@/assets/config/dicts';
import { elMessage } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'editLiveCate',
  props: {
    dialogObject: null
  },
  emits: ['dialogClose', 'dialogSuccess'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const route = useRoute();
    const sysDictList = ref([]);
    const transferProtocolObj = ref([]);
    const broadcastTypeObj = ref([]);
    const loading = ref(true);
    const formTableRef = ref(null);
    const languageList = ref([]);
    const videoencryptionList = ref([]);
    const categoryOptionList = ref([]);
    const sequenceList = ref([]);
    const statusList = ref([{
      value: 0,
      label: t('无效')
    }, {
      value: 1,
      label: t('有效')
    }]);
    const countryList = ref([]);
    const fileInput = ref();
    const priviewList = ref([]);
    const showPreview = ref(false);

    const categoryDisabled = () => {
      // 上级分类选项禁用：编辑子分类||添加子分类时
      if (props.dialogObject.mode === 'editSubcategory' || props.dialogObject.mode === 'addSubcategory') {
        return true;
      } else {
        return false;
      }
    };

    const formData = props.dialogObject.mode === 'add' ? {
      sequence: 0,
      isPremium: 0,
      status: 1,
      adult: 0,
      country: 'Global'
    } : { ...props.dialogObject.row
    }; // 获取直播分类选项

    const getLiveCategoryOptions = async params => {
      console.log('78', params);
      const {
        code,
        data
      } = await getLiveCategoryOptionsApi(params);

      if (code == 0) {
        categoryOptionList.value = data;
      }
    }; // 获取语言列表


    const getLanguageList = async () => {
      const {
        code,
        data
      } = await getLanguageListApi();

      if (code == 0) {
        languageList.value = data;
      }
    }; // 获取直播分类排序选项


    const getLiveCategorySequences = async () => {
      const {
        code,
        data
      } = await getLiveCategorySequencesApi(props.dialogObject.row.parentId);

      if (code == 0) {
        sequenceList.value = data;
      }
    };

    onMounted(() => {
      // 编辑子分类接口传参 {id:parentId} 添加子分类接口传参 {id:id}  添加一级分类和修改一级分类接口传参 {parentId: parentId}
      console.log('props.dialogObject.row', props.dialogObject.row);
      let params = {};

      switch (props.dialogObject.mode) {
        case 'editSubcategory':
          params = {
            id: props.dialogObject.row.parentId
          };
          break;

        case 'addSubcategory':
          params = {
            id: props.dialogObject.row.id
          };
          break;

        default:
          params = {
            parentId: props.dialogObject.row.parentId
          };
          break;
      }

      getLiveCategoryOptions(params);
      getLiveCategorySequences();
      getLanguageList();
      getcountryList();
      loading.value = false;
    }); // 处理props的数据 重新定义 dialogVisible

    const dialogShow = computed({
      get() {
        return props.dialogObject.dialogVisible;
      },

      set(val) {
        return val;
      }

    });
    const obj = {
      dialogTitle: props.dialogObject.title || '标题',
      dialogWidth: props.dialogObject.width || '30%',
      dialogCloseBtnText: props.dialogObject.closeBtnText || '取消',
      dialogSuccessBtnText: props.dialogObject.successBtnText || '确定',
      dialogIsFooter: props.dialogObject.isFooter || false
    };

    const close = () => {
      emit('dialogClose', false, 'close');
    };

    const validName = (rule, value, callback) => {
      if (!value) return callback(new Error(t('请输入分类名称')));
      if (value.length > 255) return callback(new Error(t('分类名称的长度应在1到255字符之间')));
      callback();
    };

    const validDescription = (rule, value, callback) => {
      if (!value || value.trim() === '') return callback();
      if (value.length > 255) return callback(new Error(t('描述的长度应在1到255字符之间')));
      callback();
    }; // 新增编辑model


    const actionForm = reactive({
      visible: false,
      // 预览图片路径
      imgUrl: '',
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        rules: {
          required: true,
          validator: validName,
          trigger: 'blur'
        }
      }, {
        label: '上级分类',
        prop: 'parentId',
        widgetType: 'Select',
        translation: true,
        list: categoryOptionList,
        rules: {
          required: true,
          message: t('请选择上级分类'),
          trigger: 'change'
        },
        disabled: categoryDisabled()
      }], [{
        label: '排序',
        prop: 'sequence',
        widgetType: 'Select',
        list: sequenceList,
        rules: {
          required: true,
          message: t('请选择排序'),
          trigger: 'change'
        }
      }, {
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        list: statusList,
        rules: {
          required: true,
          message: t('请选择状态'),
          trigger: 'change'
        }
      }], [// { label: '国家', prop: 'country', widgetType: 'Select', list: countryList, placeholder:'请选择国家', valueKey: 'label', rules:{required: true, message: t('请选择国家'), trigger: 'change'}}, 
      {
        label: '成人内容',
        prop: 'adult',
        widgetType: 'Select',
        list: playLevelObj,
        translation: true,
        rules: {
          required: true,
          message: t('请选择播放等级'),
          trigger: 'change'
        }
      }, {
        label: '视频解密',
        prop: 'videoEncryption',
        widgetType: 'Select',
        list: liveStore().videoEncryption
      }], [{
        label: '是否付费',
        prop: 'isPremium',
        widgetType: 'Select',
        list: [{
          label: t('是'),
          value: 1
        }, {
          label: t('否'),
          value: 0
        }],
        required: false
      }, {
        label: '图标',
        prop: 'logo',
        widgetType: 'input',
        itemSlot: true,
        required: false
      }], [{
        label: '描述',
        prop: 'description',
        widgetType: 'textarea',
        colspan: 3,
        required: false,
        maxLength: 200,
        rules: {
          validator: validDescription,
          trigger: 'blur'
        }
      }]],
      // formData是双向绑定的值
      formData,
      dialogConfig: {
        title: '新增'
      },
      confirm: async () => {
        await formTableRef.value.mForm.validate((valid, fields) => {
          if (valid) {
            emit('dialogSuccess', actionForm.formData, props.dialogObject.mode);
          } else {
            return console.log('error submit!', fields);
          }
        });
      }
    });

    const getcountryList = async () => {
      const {
        code,
        data
      } = await getcountryListApi();

      if (code == 0) {
        countryList.value = data;
      }
    };

    const uploadConfig = {
      multiple: false,
      accept: '.jpg,.png'
    }; // 处理文件选择

    const handleFileChange = async event => {
      const file = event.target.files[0];

      if (file) {
        console.log("已选择文件:", file);
        event.target.value = null; // 重置 input 的值以允许上传相同文件

        if (file.size > 512000) return elMessage('warning', t('图片大小建议在500kb以内。'));

        try {
          loading.value = true;
          let formData = new FormData();
          formData.append('file', file);
          const {
            code,
            data
          } = await getImageUrlByUploadApi(formData);

          if (code == 0) {
            actionForm.formData.logo = data ? data : '';
            priviewList.value = [actionForm.formData.logo];
          }
        } catch (error) {} finally {
          loading.value = false;
        }
      }
    }; // 触发文件上传输入框


    const triggerFileInput = () => {
      fileInput.value[0].click();
    }; // 删除图片


    const onDeleteImg = () => {
      actionForm.formData.logo = ''; //formTableRef.value.mForm.validateField('logoUrl')
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_MPreview = _resolveComponent("MPreview");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogShow),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(dialogShow) ? dialogShow.value = $event : null),
        title: _ctx.$t(obj.dialogTitle),
        width: obj.dialogWidth,
        "before-close": close,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [obj.dialogIsFooter ? (_openBlock(), _createElementBlock("span", _hoisted_9, [_createVNode(_component_el_button, {
          class: "btn-mixins-clear-default",
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(obj.dialogCloseBtnText)), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "btn-mixins dia-suc",
          type: "primary",
          onClick: actionForm.confirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(obj.dialogSuccessBtnText)), 1)]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-data": actionForm.formData,
          ref_key: "formTableRef",
          ref: formTableRef
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
            return _openBlock(), _createBlock(_component_FormItem, {
              "form-item": item,
              "form-data": actionForm.formData
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'logo' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!actionForm.formData.logo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                onClick: triggerFileInput
              }, {
                default: _withCtx(() => [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('点击上传')), 1)]),
                _: 1
              })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
                src: _imports_0,
                class: "view_icon",
                onClick: _cache[0] || (_cache[0] = $event => showPreview.value = true)
              }), _createVNode(_component_el_image, {
                class: "img_content",
                src: actionForm.formData.logo,
                fit: "cover"
              }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
                type: "text",
                onClick: triggerFileInput
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('更换')), 1)]),
                _: 1
              }), _createVNode(_component_el_button, {
                type: "text",
                style: {
                  "color": "#F56C6C"
                },
                onClick: onDeleteImg
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
                _: 1
              })])])), _createElementVNode("input", _mergeProps({
                type: "file",
                ref_for: true,
                ref_key: "fileInput",
                ref: fileInput
              }, uploadConfig, {
                onChange: handleFileChange,
                style: {
                  "display": "none"
                }
              }), null, 16)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data"]);
          }), 256))]),
          _: 1
        }, 8, ["form-data"])), [[_directive_loading, loading.value]]), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["modelValue", "title", "width"]), _createVNode(_component_MPreview, {
        modelValue: showPreview.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showPreview.value = $event),
        imgs: priviewList.value
      }, null, 8, ["modelValue", "imgs"])]);
    };
  }

});